import React from 'react';
import './profileMenu.scss';

const LoggedInUserProfileMenu = ({ user, menuOptions }) => {
  return (
    <ul className="dropdown-menu">
      <li>
        <a>
          <span>{user.username}</span>
        </a>
      </li>
      {menuOptions.map((option) => (
        <li className="item" key={option.title}>
          <a onClick={option.onClick}>
            <option.icon className="icon" />
            {option.title}
          </a>
        </li>
      ))}
    </ul>
  );
}

export default LoggedInUserProfileMenu;
